<template>
  <div class="introduction" :style="{ backgroundImage: `url(${item.img})`}">
    <div class="contain">
      <!-- <div class="wrap">
        <h1 class="title">项目介绍</h1>
        <p
          class="text"
        >配件新零售项目是卡车之家依托互联网技术、大数据和相关管理系统赋能传统门店转型和升级的电商服务体系。它将线上店铺和线下实体店完全打通，覆盖全量用户，解决传统商家客流有限的痛点，提升运营效率。是卡车之家重塑商用车后市场业态结构，并对线上服务、线下体验以及现代物流进行深度融合的重点项目。</p>
        <a class="btn" :href="item.info1">查看官网</a>
      </div>-->
      <div class="show" @click="go(item.link)"></div>
      <ai1></ai1>
    </div>
  </div>
</template>
<script>
import XHR from '../api'
import Ai1 from '@/components/Ai1.vue'
export default {
  name: 'Introduction',
  props: [],
  data: () => ({
    item: {}
  }),
  components: {
    Ai1
  },
  created () {
  },
  mounted () {
    this.getHandWork()
  },
  computed: {
    hid: function (params) {
      return this.deviceType === 'pc' ? 4122 : 4115
    }
  },
  methods: {
    getHandWork () {
      XHR.getHandWork({
        type: 27,
        hid: this.hid
      }).then(res => {
        const { status, data } = res.data
        if (!status) {
          this.item = data[0]
        }
      }).catch(err => {
        console.log(err)
      })
    },
    go (url) {
      this.sendAnalytics('配件新零售招商专题活动', '查看官网', '')
      window.location.href = url
    }
  }
}
</script>
<style lang="less" scoped>
.introduction {
  position: relative;
  width: 100%;
  height: 388px;
  box-sizing: border-box;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: cover;
  .contain {
    width: 100%;
    height: 100%;
    position: relative;
    .show {
      width: 120px;
      height: 50px;
      position: absolute;
      left: 0;
      top: 290px;
      cursor: pointer;
      opacity: 0;
      z-index: 100;
    }
    .ai {
      position: absolute;
      top: 160px;
      right: -150px;
      z-index: 100;
    }
  }
}
@media screen and (min-width: 376px) {
  .introduction {
    width: auto;
    max-width: 1920px;
    height: 686px;
    display: flex;
    justify-content: center;
    padding-top: 190px;
    background-size: auto;
    margin: auto;
    .contain {
      position: relative;
      width: 1200px;
      display: flex;
      justify-content: flex-end;
      .show {
        width: 170px;
        height: 50px;
        position: absolute;
        left: 0;
        top: 290px;
        cursor: pointer;
        opacity: 0;
        z-index: 100;
      }
      .ai {
        position: relative;
        top: unset;
        right: unset;
        z-index: unset;
      }
      .wrap {
        .title {
          margin: 50px 0 20px;
          font-size: 40px;
          color: #000000;
          text-align: left;
          line-height: 50px;
        }
        .text {
          margin-bottom: 30px;
          width: 640px;
          font-size: 16px;
          color: #6d7278;
          line-height: 28px;
        }
        .btn {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 166px;
          height: 44px;
          background: #3d72f5;
          font-size: 16px;
          color: #ffffff;
          line-height: 44px;
          &::after {
            margin-left: 4px;
            content: "\e7fb";
            display: inline-block;
            font-family: "iconfont";
          }
          &::before {
            // margin-left: 4px;
            content: "点击";
            display: inline-block;
            // font-family: "iconfont";
          }
        }
      }
    }
  }
}
</style>
